import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'readableDate' })
export class ReadableDatePipe implements PipeTransform {
  transform(value: number, ...args: any[]) {
    let fecha = new Date(value);
    let hoy = new Date();
    let timeDiff = hoy.getTime() - fecha.getTime();
    let diffDays = Math.floor(timeDiff / (1000 * 3600 * 24));

    let cantidad, unidad;
    if (diffDays == 0) {
      return 'Hoy';
    } else if (diffDays == 1) {
      return 'Ayer';
    } else if (diffDays < 7) {
      cantidad = diffDays;
      unidad = 'días';
    } else if (diffDays >= 7 && diffDays <= 14) {
      cantidad = diffDays % 7;
      unidad = cantidad > 1 ? 'semanas' : 'semana';
    } else {
      return fecha.getDay() + '/' + fecha.getMonth() + '/' + fecha.getFullYear() + this.getTme(fecha);
    }

    return 'Hace ' + cantidad + ' ' + unidad;
  }

  private getTme(fecha: Date): string {
    return ' ' + fecha.getHours() + ':' + fecha.getMinutes() + ' hs';
  }
}
